var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#4D535C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2601_40427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0252 13.8473L18.5943 17.4157L17.4152 18.5948L13.8469 15.0257C12.5191 16.09 10.8677 16.6689 9.16602 16.6665C5.02602 16.6665 1.66602 13.3065 1.66602 9.1665C1.66602 5.0265 5.02602 1.6665 9.16602 1.6665C13.306 1.6665 16.666 5.0265 16.666 9.1665C16.6684 10.8682 16.0895 12.5196 15.0252 13.8473ZM13.3535 13.229C14.4111 12.1414 15.0017 10.6835 14.9993 9.1665C14.9993 5.94317 12.3885 3.33317 9.16602 3.33317C5.94268 3.33317 3.33268 5.94317 3.33268 9.1665C3.33268 12.389 5.94268 14.9998 9.16602 14.9998C10.683 15.0022 12.1409 14.4116 13.2285 13.354L13.3535 13.229V13.229Z",
    fill: "\\bcurrent"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2601_40427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLine);
export default __webpack_public_path__ + "static/media/search-line.ca6cbf1e3ac5c59c4a128652d931942c.svg";
export { ForwardRef as ReactComponent };